import request from "@/global/request/request";
import API from "@/global/request/api";

const settingService = {
  withdrawalUser() {
    return request.get(API.settingWithdrawalUser);
  },
  addBankAccount(params = {}) {
    return request.post(API.settingWithdrawal, params);
  },
  editBankAccount(id, params = {}) {
    return request.put(API.settingWithdrawalItem(id), params);
  },
  autoWithdrawal(id) {
    return request.put(API.settingWithdrawalAuto(id));
  },
  profiles() {
    return request.get(API.settingProfiles);
  },
  editProfiles(params) {
    return request.put(API.settingProfiles, params);
  },
  realNameVerifies() {
    return request.get(API.settingRealnameVerifies);
  },
  editRealNameVerifies(params) {
    return request.put(API.settingRealnameVerifies, params);
  },
  stages() {
    return request.get(API.settingStages);
  }
};

export default settingService;
